import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const REASONS = [
  ["full", "Keine freien Anzeigenplätze mehr", "Leider sind für diese Ausgabe keine freien Anzeigenplätze mehr vorhanden."],
  ["partner", "Kollidiert mit Partnern/Sponsoren", "Leider kollidiert Ihre Anzeige mit den Vereinbarungen unserer Partner und Sponsoren, sodass wir sie in dieser Ausgabe nicht platzieren können."],
  ["free", "Eigener Text", ""],
];

export function DeclineDialog({ customer, onCancel, onConfirm }) {
  const [reason, setReason] = useState("full");
  const [text, setText] = useState("");
  const chef = !!useAuth().user?.is_chef;
  const [mail, setMail] = useState(chef);
  const value = reason === "free" ? text : REASONS.find((r) => r[0] === reason)[2];
  return (
    <Dialog open={!!customer} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent data-testid="decline-dialog">
        <DialogHeader>
          <DialogTitle>Absage an {customer?.name}</DialogTitle>
          <DialogDescription>Der Grund wird über den Platzhalter {"{{absagegrund}}"} in die Systemmail „Absage Anzeigenbuchung“ eingesetzt.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {REASONS.map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 text-sm cursor-pointer">
              <input type="radio" name="reason" checked={reason === k} onChange={() => setReason(k)} className="accent-slate-900" data-testid={`decline-reason-${k}`} /> {l}
            </label>
          ))}
          <Textarea value={value} onChange={(e) => { setReason("free"); setText(e.target.value); }} rows={3} data-testid="decline-text" />
          {chef && <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={mail} onChange={(e) => setMail(e.target.checked)} className="accent-slate-900" data-testid="decline-send-mail" /> Absage-Mail an den Kunden senden</label>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="decline-cancel">Abbrechen</Button>
          <Button onClick={() => onConfirm({ reason: value, send_mail: chef && mail })} disabled={mail && !value.trim()} className="bg-red-600 hover:bg-red-700" data-testid="decline-confirm">Absagen</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
